// src/main.js
import { createApp } from "vue";
import { createBootstrap } from "bootstrap-vue-next";

import App from "./App.vue";
import router from "./router";

// Import Bootstrap and BootstrapVue CSS
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "./assets/styles.css";

const app = createApp(App);
app.use(createBootstrap());
app.use(router);
app.mount("#app");
